import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

import { TEntityOverride } from 'src/types'
import Flow from 'src/adminPanel/Flow'
import StatusInput from 'src/components/flow/StatusInput'

import ListBulkActions from '../Diagram/Actions/ListBulkActions'
import EditDiagramToolbar from '../Diagram/Actions/EditDiagramToolbar'
import CreateDiagram from '../Diagram/Actions/CreateDiagram'

const override: TEntityOverride<TEntityUntagged<'Module'>> = {
  titleField: 'name',
  global: {
    properties: {
      id: {
        displayedName: 'ID',
      },
      name: {
        displayedName: 'Name',
      },
      groups: {
        displayedName: 'Owners',
        type: 'groups',
      },
      status: {
        displayedName: 'Status',
      },
      data: { hidden: true },
      author: {
        type: 'object',
        displayedName: 'Author',
        reference: {
          target: 'Passport',
          idKeyPath: 'passportId',
          labelKeyPath: 'userName',
          targetLabelKeyPath: 'username',
        },
        readOnly: true,
      },
      createdAt: {
        displayedName: 'Created',
      },
      lastUpdate: {
        displayedName: 'Modified',
      },
    },
  },
  list: {
    displayedListToolbar: ListBulkActions,
    properties: {
      status: {
        type: 'DiagramStatus',
      },
    },
  },
  create: {
    displayedComponent: CreateDiagram,
    properties: {
      id: {
        hidden: true,
      },
      createdAt: {
        hidden: true,
      },
      lastUpdate: {
        hidden: true,
      },
      status: {
        displayedComponent: StatusInput,
        defaultValue: 'stopped',
      },
    },
  },
  edit: {
    // @ts-expect-error
    redirect: false,
    displayedComponent: Flow,
    displayedFormToolbar: EditDiagramToolbar,
    properties: {
      events: {
        hidden: true,
      },
      lastUpdate: {
        hidden: true,
      },
      status: {
        displayedComponent: StatusInput,
      },
    },
  },
}

export default override
